/**
 * map
 */

import $ from "jquery";
import anime from "animejs";
import Component, { subscribe } from "../../js/lib/component";
import Page from "../page/page";

/* global ymaps */

const classList = {
  root: ".js-map",
  box: ".js-map-box",
  container: ".js-map-container",
  close: ".js-map-close",
  overlay: ".js-map-overlay"
};

export default class Map extends Component {
  events() {
    this.$.document.on("click", "[data-map]", e => this.handler(e, "open"));
    this.$.close.on("click", e => this.handler(e, "close"));
    this.$.overlay.on("click", e => this.handler(e, "close"));
    subscribe("page:esc", e => this.handler(e, "close"));
  }
  handler(e, type) {
    if (this.state.animating) return;

    const action = {
      open: e => {
        const $target = $(e.target);
        const coords = $target.data("map");

        this.state.animating = true;

        this.open().then(() => {
          this.state.animating = false;
          this.load().then(() => {
            const params = {
              center: coords,
              zoom: 15
            };

            this.map(params);
            this.marker(coords);
            this.$.root.addClass("is-inited");
          });
        });
      },
      close: () => {
        this.state.animating = true;
        this.close().then(() => {
          this.state.animating = false;
        });
      }
    };

    try {
      action[type](e);
    } catch (error) {
      console.error("Type not received");
    }
  }
  open() {
    const root = this.$.root.get(0);
    const container = this.$.container.get(0);
    const overlay = this.$.overlay.get(0);

    Page.bodyOverflowEnable();

    anime.set(root, {
      display: "block"
    });

    anime.set(container, {
      opacity: 0,
      translateY: -20
    });

    anime.set(overlay, {
      opacity: 0
    });

    return Promise.all([
      anime({
        targets: container,
        opacity: 1,
        translateY: 0,
        duration: 500,
        easing: "easeOutCubic"
      }).finished,
      anime({
        targets: overlay,
        opacity: 1,
        duration: 500,
        easing: "easeOutCubic"
      }).finished
    ]);
  }
  close() {
    const root = this.$.root.get(0);
    const container = this.$.container.get(0);
    const overlay = this.$.overlay.get(0);

    return Promise.all([
      anime({
        targets: container,
        opacity: 0,
        translateY: 20,
        duration: 500,
        easing: "easeOutCubic"
      }).finished,
      anime({
        targets: overlay,
        opacity: 0,
        duration: 500,
        easing: "easeOutCubic"
      }).finished
    ]).then(() => {
      anime.set(root, { display: "none" });
      this.$.root.removeClass("is-inited");
      Page.bodyOverflowDisable();
    });
  }
  load() {
    return new Promise(resolve => {
      if (Boolean(window.ymaps)) {
        resolve();
      } else {
        $.getScript("//api-maps.yandex.ru/2.1/?lang=ru_RU", () => {
          ymaps.ready(() => {
            resolve();
          });
        });
      }
    });
  }
  map(params) {
    this.$.box.html("");

    this.ymap = new ymaps.Map(
      this.$.box.get(0),
      {
        center: params.center,
        zoom: params.zoom,
        controls: []
      },
      {
        searchControlProvider: false
      }
    );

    const zoomControl = new ymaps.control.ZoomControl({
      options: {
        size: "small",
        position: {
          left: "auto",
          right: 20,
          bottom: 20
        }
      }
    });

    this.ymap.behaviors.disable("scrollZoom");
    this.ymap.controls.add(zoomControl);
  }
  marker(coords) {
    const marker = new ymaps.Placemark(
      coords,
      {},
      {
        iconImageHref: "/img/marker.svg",
        iconLayout: "default#image",
        iconImageSize: [66, 55],
        iconImageOffset: [-16, -52]
      }
    );

    this.ymap.geoObjects.add(marker);
  }
}

Component.mount(Map, {
  name: "Map",
  singletin: true,
  classList,
  state: {
    loaded: false,
    animating: false
  }
});
